import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = (process.env.REACT_APP_API_BASE || '/api').replace(/["']/g, '').replace(/\/+$/, '');

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
const chip = (bg, fg) => ({ padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, background: bg, color: fg, textTransform: 'capitalize', marginRight: 6, display: 'inline-block' });

export default function TutorDashboard() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [me, setMe] = useState(null);

  useEffect(() => {
    try { setMe(JSON.parse(localStorage.getItem('user') || 'null')); } catch { setMe(null); }
    load();
  }, []);

  const load = async () => {
    try {
      const res = await fetch(`${API_BASE}/tutor/students`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      if (!res.ok) {
        const b = await res.json().catch(() => ({}));
        throw new Error(b.error || `Failed to load students (${res.status})`);
      }
      setStudents(await res.json());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login', { replace: true });
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>⏳ Loading your students…</div>;

  return (
    <div style={{ maxWidth: 1100, margin: '30px auto', padding: 24, background: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h2 style={{ margin: 0 }}>👨‍🏫 My Students</h2>
          {me?.name && <p style={{ color: '#666', margin: '4px 0 0 0' }}>Welcome, {me.name}</p>}
        </div>
        <button onClick={handleLogout} style={{ padding: '10px 16px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>Logout</button>
      </div>

      {error && <div style={{ padding: 14, background: '#f8d7da', color: '#721c24', borderRadius: 6, marginBottom: 16 }}>❌ {error}</div>}

      {students.length === 0 ? (
        <p style={{ color: '#888' }}>No students assigned to you yet.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: 16 }}>
          {students.map(s => {
            const subs = s.assigned_subjects || [];
            const latest = s.latest_by_subject || {};
            return (
              <div key={s.student_id} style={{ background: '#fff', border: '1px solid #ddd', borderRadius: 8, padding: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                  <div>
                    <h3 style={{ margin: '0 0 4px 0' }}>{s.first_name} {s.last_name}</h3>
                    <div style={{ fontSize: 13, color: '#666' }}>
                      Center ID: {s.student_code || '—'} · Grade: {s.current_grade || '—'}
                    </div>
                    <div style={{ fontSize: 13, color: '#666' }}>School: {s.school_name || '—'}</div>
                  </div>
                </div>

                <div style={{ margin: '10px 0' }}>
                  <strong style={{ fontSize: 13 }}>Subjects: </strong>
                  {subs.length ? subs.map(sub => <span key={sub} style={chip('#e7f1ff', '#0056b3')}>{sub}</span>) : <span style={{ color: '#888' }}>—</span>}
                </div>

                <div style={{ display: 'grid', gap: 8, margin: '10px 0' }}>
                  {subs.map(sub => {
                    const L = latest[sub];
                    return (
                      <div key={sub} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8f9fa', borderRadius: 6, padding: '8px 10px' }}>
                        <span style={{ textTransform: 'capitalize', fontWeight: 600, fontSize: 13 }}>{sub}</span>
                        <span style={{ fontSize: 13, color: '#333' }}>
                          {L ? (
                            <>
                              <strong>{L.score ?? '—'}</strong>
                              <span style={{ color: '#888', marginLeft: 6 }}>{fmtDate(L.completed_at)}</span>
                            </>
                          ) : <span style={{ color: '#aaa' }}>No completed exam yet</span>}
                        </span>
                      </div>
                    );
                  })}
                </div>

                <button
                  onClick={() => navigate(`/tutor/students/${s.student_id}`)}
                  style={{ width: '100%', padding: '10px', background: '#007BFF', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                >
                  View Student
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}